<template>
  <el-dialog
    class="dialog-simple"
    :visible.sync="visible"
    :title="dialogTitle"
    width="980px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      :size="size"
      ref="dataForm"
      label-position="right"
      label-width="120px"
      v-loading="dialogLoading"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="工单名称">
            <el-input
              v-model.trim="dataForm.name"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="type" label="类别">
            <el-select
              v-model="dataForm.type"
              style="width: 100%;"
              placeholder=""
              clearable
              @change="handleTypeChange"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="startTime" label="开始日期">
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%;"
              v-model="dataForm.startTime"
              type="datetime"
              value-format="yyyy/MM/dd HH:mm:ss"
              placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="endTime" label="结束日期">
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%;"
              v-model="dataForm.endTime"
              type="datetime"
              value-format="yyyy/MM/dd HH:mm:ss"
              placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item prop="workingArea" label="工作范围">
            <el-input v-model.trim="dataForm.workingArea" placeholder="" clearable></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item prop="equipment" label="关联设备">
            <div class="tree-content">
              <el-tree
                :data="treeData"
                show-checkbox
                default-expand-all
                node-key="measureId"
                ref="tree"
                highlight-current
                :props="defaultProps"
              >
              </el-tree>
            </div>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item prop="describe" label="描述">
            <el-input type="textarea" :rows="2" placeholder="" v-model="dataForm.describe">
            </el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item prop="describe" label="附件">
            <el-upload
              class="upload-demo"
              action="#"
              :before-upload="beforeUpload"
              :http-request="httpRequest"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              multiple
              :limit="10"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button
        class="submit"
        :size="size"
        type="primary"
        @click="submitHandle()"
        :loading="dialogLoading"
        >确 定</el-button
      >
      <el-button class="close" :size="size" @click="visible = false"
        >取 消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import tree from "@/utils/tree";
import debounce from "lodash/debounce";
export default {
  name: "orderCreate",
  props: {
    dialogTitle: {
      type: String,
      default: "派单",
    },
    isRedispatch: {
      type: Boolean,
      default: false,
    },
    typeList: Array,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      size: "small",
      dialogLoading: false,
      visible: false,
      dataForm: {
        companyId: 0,
        name: "",
        contractId: "",
        type: "",
        startTime: "",
        endTime: "",
        describe: "",
        workingArea: "",
        equipment: [],
        attachments: [],
        planId: 0,
        clientEventRecordId: 0,
      },
      equipmentList: [],
      fileList: [],
      contract: {},
      services: [],
      upLoadList: [],
      treeData: [],
      types: {
        1: "站点改造",
        2: "抢修",
        3: "试验",
        4: "巡检",
        5: "其它",
        6: "带电检测",
        7: "电能安装",
      },
      defaultProps: {
        label: "measureName",
        children: "children",
        disabled: this.disabledFn,
      },
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        type: [{ required: true, message: "不能为空", trigger: "blur" }],
        startTime: [{ required: true, message: "不能为空", trigger: "blur" }],
        endTime: [{ required: true, message: "不能为空", trigger: "blur" }],
        // equipment: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ]
      };
    },
  },
  methods: {
    disabledFn() {
      return true;
    },
    async init(row, title) {
      console.log(row);
      this.title = title;
      this.visible = true;
      this.dataForm = {
        companyId: 0,
        name: "",
        contractProjectId: "",
        type: "",
        startTime: "",
        endTime: "",
        describe: "",
        workingArea: "",
        attachments: [],
        measureIdList: [],
        planId: 0,
        clientEventRecordId: 0,
      };
      this.fileList = [];
      this.treeData = [];
      const clientCompanyId = row.clientCompanyId;
      const res = await this.$api.electricOperations.getMOViewTreeNodes(
        clientCompanyId
      );
      if (res.success) {
        const list = res.data.map((item) => {
          return {
            ...item,
            disabled: true,
          };
        });
        this.treeData = tree.creatMeasureTreeJson(list, 0);
      }
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.dataForm.planId = row.id;
        this.dataForm.contractProjectId = row.contractProjectId;
        this.dataForm.type = row.type;
        this.dataForm.measureIdList = row.projectInfoVO.scopes.map(
          (measure) => {
            return measure.measureId;
          }
        );
        // const measureId = row.projectInfoVO.scopes.map((measure) => {
        //   return measure.measureId
        // })
        this.$refs.tree.setCheckedKeys(this.dataForm.measureIdList);
        Promise.all([this.handleContractInfo(row.contractId)]).then(() => {
          if (this.isRedispatch) {
            this.handleGetInfo();
          }
        });
      });
    },
    handleGetInfo() {},
    handleContractInfo(id) {
      this.$api.electricOperations
        .getElectricOperationsContractInfo([id])
        .then((res) => {
          if (res.success) {
            this.contract = res.data[0];
            this.services = this.contract.services.map((item) => {
              let params = item.params === "" ? {} : JSON.parse(item.params);
              // console.log(this.typeList[item.type])
              return {
                name: this.types[item.type],
                ...item,
                ...params,
              };
            });
            console.log(this.services);
            this.handleTypeChange(this.dataForm.type);
          }
        });
    },
    handleTypeChange(val) {
      this.services.forEach((item) => {
        if (item.type == val) {
          console.log(item);
          this.handleGetMeasures(item.measures);
        }
      });
    },
    handleGetMeasures(list) {
      if (list && list.length > 0) {
        this.$api.measure.getMeasuresProperties(list).then((res) => {
          if (res.success) {
            this.dataForm.equipment = [];
            this.equipmentList = res.data;
            this.dataForm.equipment = this.equipmentList.map((item) => {
              return item.id;
            });
          }
        });
      }
    },
    handleSuccess(res, file, fileList) {
      console.log(res, file, fileList);
    },
    beforeUpload(file) {
      console.log(file);
      const rd = new FileReader();
      rd.readAsDataURL(file);
      const fileName = file.name;
      rd.onload = () => {
        const data = rd.result.split(",")[1];
        this.$api.file
          .pushCompanyFileToOss(0, fileName, "", "", data)
          .then((res) => {
            if (res?.success) {
              this.fileList.push({
                id: res.data?.id,
                name: fileName,
              });
            }
          });
      };
    },
    httpRequest(res) {
      // console.log(res)
      // const rd = new FileReader()
      // const file = data.file
      // rd.readAsDataURL(file)
      // const fileName = file.name
      // rd.onload = () => {
      //   const data = rd.result.split(',')[1]
      //   this.$api.file.pushCompanyFileToOss(0, fileName, '', '', data).then((res) => {
      //     if (res?.success) {
      //       console.log(res)
      //       this.fileList.push({
      //         id: 0,
      //         name: fileName
      //       })
      //     }
      //   })
      // }
    },
    handleRemove(file, fileList) {
      this.fileList.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.fileList.splice(index, 1);
        }
      });
      console.log(file, fileList, this.fileList);
    },
    submitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.dialogLoading = true;
          this.dataForm.attachments = this.fileList.map((item) => {
            return item.id;
          });
          this.$api.electricOperations
            .addElectricOperationsWorkOrder({ ...this.dataForm })
            .then((res) => {
              this.dialogLoading = false;
              if (res.success) {
                this.$message.success("操作成功");
                this.visible = false;
                this.$emit("handleQuery");
              }
            });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss" scoped>
.dialog-simple {
  .upload-demo {
    text-align: left;
  }
}

.equipment {
  text-align: left;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  width: 100%;
  word-break: break-all;
}

.tree-content {
  ::v-deep .el-checkbox.is-disabled.is-checked {
    color: #409eff;
    .el-checkbox__inner {
      background-color: #409eff;
      border-color: #409eff;
      &::after {
        border-color: #fff;
      }
    }
  }
}
</style>
